export enum Lang {
	French = 'fr',
	English = 'en'
}